import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'sectionsView',
  setup(__props) {

const sections = [
  {
    name: 'gallery',
    title: 'Galería',
    description: 'Explora todas las imágenes organizadas por tipo de evento y estilo visual.',
    icon: 'mdi-image-multiple',
    image: '/imgs/sections/Online gallery-bro.svg',
    route: '/gallery'
  },
  {
    name: 'nosotros',
    title: 'Nosotros',
    description: 'Conoce quiénes somos, nuestra historia y cómo hacemos realidad tu boda.',
    icon: 'mdi-account-group',
    image: '/imgs/sections/About us page-pana.svg',
    route: '/nosotros'
  },
  {
    name: 'servicios',
    title: 'Servicios',
    description: 'Descubre los servicios que ofrecemos para bodas únicas e inolvidables.',
    icon: 'mdi-cog-outline',
    image: '/imgs/sections/Data processing-bro.svg',
    route: '/servicios'
  },
  {
    name: 'testimonios',
    title: 'Testimonios',
    description: 'Lee las experiencias de nuestros clientes y cómo vivieron su gran día.',
    icon: 'mdi-comment-quote-outline',
    image: '/imgs/sections/Online Review-bro.svg',
    route: '/testimonios'
  },
  {
    name: 'contacto',
    title: 'Contacto',
    description: 'Ponte en contacto con nosotros para cotizar tu evento o resolver dudas.',
    icon: 'mdi-phone',
    image: '/imgs/sections/Connected-cuate.svg',
    route: '/contacto'
  }
]

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _cache[0] || (_cache[0] = _createElementVNode("h1", { class: "text-h5 mb-6" }, "Secciones del Sitio", -1)),
      _createVNode(_component_v_row, { dense: "" }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sections, (section) => {
            return _createVNode(_component_v_col, {
              key: section.name,
              cols: "12",
              sm: "6",
              md: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, {
                  class: "mx-auto",
                  "max-width": "400",
                  outlined: "",
                  hover: "",
                  to: section.route
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_img, {
                      src: section.image,
                      height: "160px",
                      cover: ""
                    }, null, 8, ["src"]),
                    _createVNode(_component_v_card_title, { class: "d-flex align-center" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(section.title), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(section.description), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              _: 2
            }, 1024)
          }), 64))
        ]),
        _: 1
      })
    ]),
    _: 1,
    __: [0]
  }))
}
}

})